import { action, persist} from "easy-peasy";
import { useEffect } from "react";


const projectModel = persist({
  projectViewDatas: null,
  projectViewScreen: false,
  projectEditValue: null,
  addProjects: false,
  filterProjects: null,
  userDashboardFilterProjects: null,
  subTaskProjectName: null,
  subTaskRedirect: null,
  fromDashboard: null,
  loginDetails: null,
  roleDetails: null,
  employeeName: null,
  viewScreen: false,
  viewScreenHod: false,
  subTaskProjectNameUser: null,
  subTaskRedirectUser: null,
  fromDashboardUser: null,
  menuIcon: false,
  ganttWorkbook: null,
  userIdLogin: null,

  setProjectViewDatas: action((state, payload) => {
    state.projectViewDatas = payload;
  }),
  setProjectViewScreen: action((state, payload) => {
    state.projectViewScreen = payload;
  }),
  setProjectEditValue: action((state, payload) => {
    state.projectEditValue = payload;
  }),
  setAddProjects: action((state, payload) => {
    state.addProjects = payload;
  }),
  setFilterProjects: action((state, payload) => {
    state.filterProjects = payload;
  }),
  setUserDashboardFilterProjects: action((state, payload) => {
    state.userDashboardFilterProjects = payload;
  }),
  setSubTaskProjectName: action((state, payload) => {
    state.subTaskProjectName = payload;
  }),
  setSubTaskRedirect: action((state, payload) => {
    state.subTaskRedirect = payload;
  }),
  setSubTaskProjectNameUser: action((state, payload) => {
    state.subTaskProjectNameUser = payload;
  }),
  setSubTaskRedirectUser: action((state, payload) => {
    state.subTaskRedirectUser = payload;
  }),
  setFromDashboardUser: action((state, payload) => {
    state.fromDashboardUser = payload;
  }),
  setFromDashboard: action((state, payload) => {
    state.fromDashboard = payload;
  }),
  setLoginDetails: action((state, payload) => {
    state.loginDetails = payload;
  }),
  setRoleDetails: action((state, payload) => {
    state.roleDetails = payload;
  }),
  setEmployeeName: action((state, payload) => {
    state.employeeName = payload;
  }),
  setViewScreen: action((state, payload) => {
    state.viewScreen = payload;
  }),
  setViewScreenHod: action((state, payload) => {
    state.viewScreenHod = payload;
  }),
  setMenuIcon: action((state, payload) => {
    state.menuIcon = payload;
  }),
  setGanttWorkbook: action((state, payload) => {
    state.ganttWorkbook = payload;
  }),
  setUserIdLogin: action((state, payload) => {
   state.userIdLogin = payload;
  }),
});


export default projectModel;


